<template>
  <div>
    <rj-tabs v-model="tabsActive">
      <rj-tab-pane name="1">
        <span slot="label">待确认批次付款</span>
        <BatchToBeConfirmed />
      </rj-tab-pane>
      <rj-tab-pane name="2">
        <span slot="label">已确认批次付款</span>
        <BatchConfirmed />
      </rj-tab-pane>
      <rj-tab-pane name="3">
        <span slot="label">待确认返利抵应收</span>
        <RebateReceivable type="PENDING" />
      </rj-tab-pane>
      <rj-tab-pane name="4">
        <span slot="label">已确认返利抵应收</span>
        <RebateReceivable type="APPROVED" />
      </rj-tab-pane>
    </rj-tabs>
  </div>
</template>

<script>
import tabs from '@/components/Tabs/tabs';
import tabPane from '@/components/Tabs/tabPane';
import BatchConfirmed from './components/BatchConfirmed.vue';
import BatchToBeConfirmed from './components/BatchToBeConfirmed.vue';
import RebateReceivable from '../rebateManagement/RebateReceivable.vue';
export default {
  components: {
    'rj-tab-pane': tabPane,
    'rj-tabs': tabs,
    BatchConfirmed,
    BatchToBeConfirmed,
    RebateReceivable
  },
  data () {
    return {
      tabsActive: this.$route.query.tab || '1'
    };
  },
  watch: {
    '$route.query.tab' (val) {
      this.tabsActive = val || '1';
    }
  },
  computed: {},
  mounted () {},
  methods: {}
};
</script>

<style>

</style>
